import state from './moduleDailyCoverState'
import actions from './moduleDailyCoverActions'
import getters from './moduleDailyCoverGetters'
import mutations from './moduleDailyCoverMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

